<script>
import step1 from '~/pages/_lang/create-seller-account/step1'
export default step1
</script>
